import { Link } from "react-router-dom";

interface Crumb {
  label: string;
  to?: string;
}

interface BreadcrumbProps {
  items: Crumb[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航" className="flex flex-wrap items-center gap-1 text-sm text-foreground-600">
      <Link to="/" className="transition-colors hover:text-accent-500">
        <i className="ri-home-4-line mr-1 align-middle"></i>
        首页
      </Link>
      {items.map((item) => (
        <span key={item.label} className="flex items-center gap-1">
          <i className="ri-arrow-right-s-line text-base text-foreground-500"></i>
          {item.to ? (
            <Link to={item.to} className="transition-colors hover:text-accent-500">
              {item.label}
            </Link>
          ) : (
            <span className="text-foreground-950">{item.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}